import styled from 'styled-components';
export var CellWithCheckbox = styled.div.withConfig({
  displayName: "partials__CellWithCheckbox",
  componentId: "sc-86yui2-0"
})(["display:flex;align-items:center;"]);
export var CheckboxInner = styled.div.withConfig({
  displayName: "partials__CheckboxInner",
  componentId: "sc-86yui2-1"
})(["margin-right:6px;"]);